import type { UseMomentProperties } from "../moment-card/types";
import type { Moment } from "../moment/types";

// isManagerConnection is a helper to encompass both manager and connection whilst
// we support both in parallel
export type ToTarget =
  | {
      toTarget: "channel";
      target_connection_type: null;
      isManagerConnection: false;
      notify_channel: boolean;
    }
  | {
      toTarget: "notify" | "employee";
      target_connection_type: null;
      isManagerConnection: false;
      notify_channel?: never;
    }
  | {
      toTarget: "manager";
      target_connection_type: null;
      isManagerConnection: true;
      notify_channel?: never;
    }
  | {
      toTarget: "connection";
      target_connection_type: string;
      isManagerConnection: true;
      notify_channel?: never;
    };

export function getToTarget(
  moment: Pick<
    Moment,
    | "target_channel"
    | "target_manager"
    | "only_additional_recipients"
    | "notify_channel"
    | "target_connection_type"
  >,
): ToTarget {
  return getTargetType({
    ...moment,
    target_channel: moment.target_channel ?? false,
    target_manager: moment.target_manager ?? false,
    only_additional_recipients: moment.only_additional_recipients ?? false,
    notify_channel: moment.notify_channel ?? false,
  });
}

export const getTargetType = ({
  only_additional_recipients,
  target_manager,
  target_connection_type,
  target_channel,
  notify_channel,
}: Pick<
  UseMomentProperties,
  | "only_additional_recipients"
  | "target_manager"
  | "target_connection_type"
  | "target_channel"
  | "notify_channel"
>): ToTarget => {
  if (target_channel || notify_channel)
    return {
      toTarget: "channel",
      target_connection_type: null,
      isManagerConnection: false,
      notify_channel: notify_channel ?? false,
    };

  if (only_additional_recipients)
    return { toTarget: "notify", target_connection_type: null, isManagerConnection: false };

  if (target_manager)
    return { toTarget: "manager", target_connection_type: null, isManagerConnection: true };

  // if any connection is defined, then the type is 'connection'
  if (target_connection_type)
    return { toTarget: "connection", target_connection_type, isManagerConnection: true };

  return { toTarget: "employee", target_connection_type: null, isManagerConnection: false };
};
